import { Pipe, PipeTransform } from '@angular/core'
import { Store } from '@ngrx/store'
import { AppState } from '../../../../core/core.state'
import { SaleItem } from '../sale-item'
import { Observable } from 'rxjs'
import { SaleItemPriceDetails, SaleItemService } from '../sale-item.service'

@Pipe({
  name: 'getSaleItemSubscriptionPrice'
})
export class GetSaleItemSubscriptionPricePipe implements PipeTransform {
  constructor(
    private store: Store<AppState>,
    private saleItemService: SaleItemService
  ) {}

  transform(saleItem: SaleItem): Observable<SaleItemPriceDetails> {
    return this.saleItemService.getSaleItemSubscriptionPriceDetails$(saleItem)
  }
}
